/* Bundle subscriptions add their first-box gift in the same basket request. */
(function () {
  'use strict';
  var bundleVariant = 55616209092990;
  var massagerVariant = 51909821071742;
  var busy = false;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  async function request(path, options) {
    var response = await fetch(root + path, options);
    var data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(typeof data.description === 'string' ? data.description : 'Please try adding your plan again.');
    }
    return data;
  }

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.js-product-form')) return;
    var data = new FormData(form);
    if (Number(data.get('id')) !== bundleVariant || !Number(data.get('selling_plan'))) return;
    var host = form.closest('product-form');
    var button = form.querySelector('[name="add"]');
    if (!host || !button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || button.getAttribute('aria-disabled') === 'true') return;
    if (!form.checkValidity() || (typeof host.validate === 'function' && !host.validate())) return;
    busy = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
    if (typeof host.setErrorMsgState === 'function') host.setErrorMsgState();
    try {
      var cart = await request('cart.js');
      var item = {
        id: bundleVariant,
        quantity: Number(data.get('quantity')) || 1,
        selling_plan: Number(data.get('selling_plan'))
      };
      var properties = {};
      data.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      });
      if (Object.keys(properties).length) item.properties = properties;
      var items = [item];
      if (!cart.items.some(function (line) { return line.variant_id === massagerVariant; })) {
        items.push({ id: massagerVariant, quantity: 1 });
      }
      var sections = ['page-header', 'cart-drawer'].map(function (selector) {
        return document.querySelector(selector);
      }).filter(function (element) { return element && element.dataset.sectionId; });
      var added = await request('cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: sections.map(function (element) {
          return element.dataset.sectionId;
        }), sections_url: window.location.pathname })
      });
      if (added.sections && sections.every(function (element) {
        return added.sections[element.dataset.sectionId] && typeof element.updateFromCartChange === 'function';
      })) {
        sections.forEach(function (element) { element.updateFromCartChange(added.sections[element.dataset.sectionId]); });
      } else {
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      }
      var drawer = document.querySelector('.js-cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open(button);
      host.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: bundleVariant } }));
    } catch (error) {
      if (typeof host.setErrorMsgState === 'function') host.setErrorMsgState(error.message);
      host.dispatchEvent(new CustomEvent('on:cart:error', { bubbles: true, detail: { error: error.message } }));
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    } finally {
      busy = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-disabled');
    }
  }, true);
}());
